import Vue from "vue"
import VueKeyCloak from "@founder/vue-auth-js"
import { start } from "qiankun"

import ECharts from "vue-echarts"
import "echarts/lib/chart/bar"
import "echarts/lib/component/tooltip"
Vue.component("v-chart", ECharts)

import ElementUI from "element-ui"
// import 'element-ui/lib/theme-chalk/index.css';
import "./assets/founderui.skyblue.css"
import "./assets/css/reset.css"
import "./assets/css/sprite.scss"
import "./assets/css/common.scss"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import mixin from "./mixin"
import VueClipboard from "vue-clipboard2"

// 加载导航服务代码
import "./menuService.js"

// 全局变量 本地开发环境登录时需注意
Vue.prototype.$realm =
  process.env.NODE_ENV === "development"
    ? "founderid"
    : location.hostname.split(".")[0]
Vue.config.productionTip = false
Vue.mixin(mixin)
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueKeyCloak, {
  init: {
    onLoad: "login-required"
  },
  logout: {
    redirectUri: "/"
  },
  config: {
    url: "/auth",
    clientId: "idaas",
    realm: Vue.prototype.$realm
  },
  onReady: () => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app")
    // 需要在vue挂载后，再启动菜单服务，以免菜单服务找不到存放位置，导致加载失败
    start({
      sandbox: false
    })
  }
})
